import React, { useEffect, useState } from "react";
import { Content, Row, Col, Box, Button, Inputs } from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";
import { parseJwt, validateEmail } from "../utils/utils";
import Loader from "../utils/Loader";

const { Text } = Inputs;

function AceptarTerminos({ history, match }) {
  const dispatch = useDispatch();
  const modelTerminos = useSelector((state) => state.terminos);

  useEffect(() => {
    const data = modelTerminos?.data?.data;
    const error = modelTerminos?.error?.response?.data?.mensaje;
    if (error) {
      alert(error);
      dispatch(controller.duckTerminos.actions.clear());
    }
    if (data) {
      const decodedToken = parseJwt(data.data.token);
      if (decodedToken.rol === "cliente" || decodedToken.rol === "app") {
        alert("Acceso no autorizado para clientes");
        return;
      }
      localStorage.setItem("token", data.data.token);
      dispatch(controller.duckTerminos.actions.clear());

      if (decodedToken.rol === "superadmin") {
        window.location.href = "/locales";
      }
      if (decodedToken.rol === "admin" || decodedToken.rol === "visualizador") {
        window.location.href = `/calendarioLocal/${data.data.organizacionID}`;
      }
    }
  }, [modelTerminos]);

  function submit() {
    let data = {
      id: match.params.id,
    };
    dispatch(controller.updateTerminosAceptadosThunk(data));
  }

  return (
    <Content
      title="Terminos y condiciones"
      browserTitle="Terminos y condiciones"
      show={true}
    >
      <Row>
        <Col md="6" mdOffset="3">
          <Box title="Terminos y condiciones">
            <p>
              El presente es un documento de acuerdo por parte del que suscribe,
              en adelante denominado “CLIENTE” y por otra AIRAM S.A. con RUC N.º
              80114565-1 con domicilio en Félix Bogado c/ 21 Proyectada, Barrio
              Obrero de la ciudad de Asunción Paraguay en adelante denominado
              “PRESTADOR”, que acuerdan regirse bajo los términos consignados en
              el presente documento, en adelante “El Contrato”, los cuales son
              aceptados por las partes y están estipulados a continuación:
            </p>
            <h3>I - DEFINICIONES</h3>
            <h4>1. PLATAFORMA</h4>
            <p>
              Se refiere a la página WEB “www.agendia.co” y Aplicación
              electrónica AGENDIA®, que es la herramienta informática mediante
              la cual se brindaran los servicios contratados en el presente
              contrato.
            </p>
            <h4>2. CLIENTE</h4>
            <p>
              Se refiere a toda persona física o jurídica que se adhiere a los
              servicios proveídos por EL PRESTADOR. El término CLIENTE también
              se define respectivamente y con igual valor a cotitulares o
              mandatarios o representantes legales, que firmen el Contrato.
            </p>
            <h4>3. USUARIOS</h4>
            <p>
              Es el perfil electrónico mediante el cual EL CLIENTE se registra y
              opera en la plataforma. Este consta de un correo electrónico y una
              contraseña.
            </p>
            <h4>4. USUARIOS</h4>
            <p>
              : Es el contrato de adhesión relativo a los servicios ofrecidos
              por EL PRESTADOR, cuyas cláusulas están insertas en el presente
              contrato.
            </p>
            <h4>5. MEDIOS DE COMUNICACIÓN</h4>
            <p>
              Son todos los canales que utiliza EL PRESTADOR para comunicarse
              con EL CLIENTE; telegrama colacionado, tableros de informaciones,
              correos electrónicos, página de inicio de la plataforma, mensajes
              vía celular, Diarios de circulación nacional u otras vías a ser
              habilitadas en el futuro, pudiendo EL PRESTADOR indistintamente
              utilizar todos o eventualmente cualquiera de los medios de
              comunicación indicados, conforme a su arbitrio.
            </p>
            <h4>6. ESTADOS DE CUENTA</h4>
            <p>
              Es el documento utilizado por EL PRESTADOR para informar al
              CLIENTE el resumen de movimientos con la descripción de todas las
              operaciones realizadas en un período determinado de tiempo,
              relacionado al servicio al cual se adhiere.
            </p>
            <h4>7. GASTOS</h4>
            <p>
              Costos por operaciones o servicios adicionales y/o complementarios
              a las operaciones contratadas, debidamente justificados, en que
              incurre EL PRESTADOR y pueden ser trasladados al CLIENTE.
            </p>

            <h3>II - INTRODUCCIÓN</h3>
            <p>
              AGENDIA® (www.agendia.co) es una Plataforma web y una Aplicación
              electrónica que ofrece servicios tecnológicos de intermediación
              digital a proveedores independientes de servicios utilizando un
              sistema de tecnología digital, siendo intermediario sobre demanda
              y oferta de los servicios mencionados, permitiendo a proveedores
              particulares de servicios localizar, recibir y dar cumplimiento a
              las peticiones sobre demanda de dichos servicios por parte de los
              USUARIOS que buscan servicios particulares.{" "}
            </p>

            <p>
              La PLATAFORMA ofrece cuatro tipos de planes, los cuales serán
              detallados en un anexo adjunto al presente contrato.{" "}
            </p>
            <p>
              <strong>Plan mensual LITE</strong>
            </p>
            <p>
              <strong>Plan mensual PRO</strong>
            </p>
            <p>
              <strong>Plan mensual Premium</strong>
            </p>
            <p>
              <strong>Plan mensual GOLD</strong>
            </p>
            <p>
              Integran este Contrato el anexo de planes en el cual consta el
              detalle de los servicios contratados, así como el Tarifario donde
              se fijan periódicamente el precio de los servicios prestados y así
              como toda información y/o documentación arrimada por EL CLIENTE
              que refiera y/o afecte a su relacionamiento con el prestador,
              durante la vigencia del Contrato.{" "}
            </p>

            <h3>III - CONDICIONES GENERALES</h3>
            <p>
              1. OBJETO: En virtud del presente contrato EL CLIENTE contrata al
              PRESTADOR, a fin de que este le brinde los servicios de
              intermediación de oferta y demanda mediante la PLATAFORMA, la cual
              es una herramienta que permite al CLIENTE conectar con USUARIOS
              que buscan contratar con sus servicios.{" "}
            </p>
            <p>
              2. Corresponde al CLIENTE determinar la carga de horarios para los
              turnos, carga de información de profesionales, carga de servicios,
              costos y duración en tiempo, cancelar y re-agendar citas,
              comunicar a sus clientes la cancelación o cambio de turno, y toda
              información que podrán acceder a fin de verificar sus clientes
            </p>
            <p>
              3. PRECIOS - FORMA DE PAGO: El precio que el CLIENTE deberá abonar
              mensualmente al PRESTADOR la suma indicada en el anexo de planes
              para el “plan mensual”, y lo remitido en el estado de cuenta del
              periodo del CLIENTE para el “plan por reserva”, el precio de cada
              reserva estará estipulado en el “anexo de planes”. La suma a ser
              abonada tanto en el “plan mensual” como el “plan por reserva”
              deberá pagarse del uno al cinco del mes siguiente al mes vencido.
            </p>
            <p>
              4. PLAZO: Este acuerdo tendrá una duración de un mes, a contar
              desde suscripción del presente contrato, renovándose
              automáticamente por períodos iguales de un mes salvo que
              cualquiera de las partes manifieste fehacientemente por escrito su
              intención de no proceder a la renovación con un mínimo de 30
              (treinta) días de anticipación al vencimiento del plazo
              mencionado. - El presente artículo tendrá vigencia solamente para
              EL CLIENTE que se suscriba al “plan mensual”, no así para el
              suscriptor del “plan por reserva”, el cual no estará sujeto a
              plazo.
            </p>
            <p>
              5. ESTADOS DE CUENTA: Es el documento utilizado en el “plan por
              reserva” por EL PRESTADOR para informar al CLIENTE el resumen de
              movimientos con la descripción de todas las operaciones realizadas
              en un período determinado de tiempo. El mismo se informará al
              CLIENTE con la periodicidad el último día hábil de cada mes, por
              los medios de COMUNICACIÓN del PRESTADOR, siempre y cuando éste
              registre movimientos en sus cuentas. Si el servicio contratado por
              EL CLIENTE no mostrare ningún movimiento durante el plazo del mes
              no generará extracto alguno. EL CLIENTE se compromete a revisar
              los resúmenes de cuentas que le envíe EL PRESTADOR y avisar a éste
              cualquier discrepancia. Todo reclamo deberá hacerse por escrito.
              Transcurridos 15 días de recibido el extracto de cuenta sin
              comunicarse observación alguna, EL CLIENTE no podrá formular
              reclamo alguno respecto al saldo de la cuenta que arrojan las
              constancias del PRESTADOR al último día de dicho cierre. Se
              presume que EL CLIENTE ha recibido el resumen de cuenta si es que
              no reclamare al PRESTADOR por escrito una copia del mismo dentro
              de los primeros diez días del mes siguiente al del extracto de
              cuenta. EL PRESTADOR confeccionará y enviará en el estado de
              cuenta, todas las reservas de turnos recibidas por EL CLIENTE. En
              ausencia de reclamo, todo lo especificado en el resumen más los
              ajustes e intereses que generen desde el vencimiento hasta el pago
              efectivo y cancelatorio se considerará aceptado por EL CLIENTE.
            </p>
            <p>
              6. GASTOS: Toda clase de gastos, cargos, aranceles, impuestos,
              actuales o futuros, que se relacionen directa o indirectamente con
              este Contrato, especialmente los relacionado a la mora del pago
              del servicio contratado, estarán a cargo del CLIENTE.
            </p>
            <p>
              7. REPRESENTACIÓN: Si EL CLIENTE fuera una persona jurídica, el
              Contrato será firmado o aceptado por quien o quienes la
              representen de acuerdo a la Ley o sus Estatutos. Se harán constar
              los datos del representante y se proveerá copia certificada del
              estatuto, contrato social, acta, poder o documento que acredite
              tal representación, en donde consten las facultades y régimen de
              firmas. EL CLIENTE informará al PRESTADOR, bajo su
              responsabilidad, toda modificación de poderes, estatutos,
              contratos sociales, revocaciones, fusión, disolución de
              sociedades, transferencias de fondos de comercio, concurso,
              quiebra o circunstancia que alteren la situación existente a la
              fecha del Contrato.
            </p>
            <p>
              8. CONFIDENCIALIDAD: EL PRESTADOR se obliga a no divulgar ninguno
              de los aspectos de los negocios de EL CLIENTE, ni proporcionará a
              tercera persona, verbalmente o por escrito, directa o
              indirectamente, información alguna sobre los sistemas y
              actividades de cualquier clase que observe de EL CLIENTE. Tampoco
              mostrará a terceros los documentos, expedientes, escritos,
              artículos, contratos, bitácora, estados de cuenta, y demás
              materiales e información que le proporcione EL CLIENTE o que
              prepare o formule con relación a sus servicios.
            </p>
            <p>
              9. DECLARACIÓN DE LEGALIDAD: EL CLIENTE declara bajo fe de
              juramento y se compromete con relación a todas sus actuaciones,
              operaciones y transacciones con y/o a través del PRESTADOR,
              cualquiera sea la denominación, condición o modalidad de las
              mismas, que dichas operaciones de ninguna manera están ni estarán
              relacionadas con actividades o delitos tipificados en la Ley No.
              1015/97 “Que previene y reprime los actos ilícitos destinados a la
              legitimación de dineros y bienes” y la Ley No. 1340/88 “Que
              reprime el tráfico de estupefacientes y drogas peligrosas”.
            </p>
            <p>
              10. VALIDEZ DE LAS CLÁUSULAS DEL CONTRATO: Con relación a lo
              dispuesto por el Art. 365 del Código Civil, si alguna de las
              cláusulas o condiciones de este Contrato fuere total o
              parcialmente nula, tal nulidad afectará únicamente a dicha
              disposición o cláusula. En todo lo demás, este Contrato seguirá
              válido y vinculante como si la disposición o cláusula no hubiere
              formado parte del mismo y solo lo anulará, en la medida en que la
              cláusula afectada sea nula.
            </p>
            <p>
              11. MODIFICACIONES: Este Contrato podrá ser modificado por EL
              PRESTADOR o según las normas legales vigentes. Toda modificación
              respecto a lo inicialmente pactado con EL CLIENTE deberá ser
              comunicada al mismo mediante por cualquiera de los MEDIOS DE
              COMUNICACIÓN habilitados por EL PRESTADOR, con una anticipación no
              menor a 30 días corridos a la entrada en vigor de la modificación.
              Se considerará como aceptación tácita la modificación en el caso
              de que no fuere objetada, por escrito, dentro del plazo
              mencionado, o con el mero ejercicio de las nuevas condiciones o el
              uso de los nuevos servicios emergentes de este contrato. Dicha
              modificación reemplazará a las condiciones originalmente aquí
              establecidas, razón por la cual EL CLIENTE reconoce que podrá
              acceder a la versión actualizada que se encontrará disponible en
              el sitio web del PRESTADOR www.agendia.co.
            </p>
            <p>
              12. RESCISIÓN: Cualquiera de las partes transcurrido el periodo de
              permanencia mínima previsto en el punto anterior podrá rescindir
              el presente contrato de manera unilateral con treinta días de
              anticipación, comunicando a la otra parte por escrito de manera
              fehaciente, sin responsabilidad alguna, más que el pago de los
              servicios que se encontraren pendientes de pago o ejecución. En
              caso de que EL CLIENTE presente una mora por el pago del PRECIO
              estipulado en la cláusula tercera, ya sea cliente del “plan
              mensual” o “plan por reserva” EL PRESTADOR podrá rescindir
              unilateralmente el presente contrato, sin previo aviso o
              notificación alguna, pudiendo este cesar los servicios prestados a
              EL CLIENTE, sin recaer en responsabilidad alguna. -
            </p>
            <p>
              13. NORMAS: El presente Contrato regula los Servicios prestados y
              se rige por la legislación tanto paraguaya como peruana, presente
              y futura aplicable. EL PRESTADOR no responderá por las
              consecuencias que derivaren de disturbios en el país, tales como
              guerra, huelga, paro, o de disposiciones o medidas de las
              autoridades y en general, de toda circunstancia de caso fortuito o
              de fuerza mayor, cualquiera fuera su índole.
            </p>
            <p>
              14. DOMICILIO Y JURISDICCIÓN: Para todos los efectos legales y
              acciones emergentes de este contrato, las partes se someten a la
              Jurisdicción de los Tribunales de Justicia de Lima o los
              Tribunales Ordinarios de la ciudad de Asunción, o a elección del
              PRESTADOR a los Tribunales del domicilio del CLIENTE, quien
              constituye domicilio especial en el indicado en este Contrato,
              quedando entendido que cualquier notificación que en él se
              practique, será válida y se tendrá como efectuada personalmente.
              Asimismo, EL CLIENTE se compromete a notificar al PRESTADOR, en
              forma inmediata, cualquier cambio de domicilio que se produjere
              durante la vigencia de este Contrato, caso contrario, se tendrán
              por válidas las notificaciones realizadas en el domicilio especial
              constituido en el presente Contrato.
            </p>
            <p>
              <strong>EN PRUEBA DE CONFORMIDAD Y ACEPTACIÓN</strong>, comprometiéndose al fiel
              cumplimiento de sus obligaciones, suscriben las partes de un mismo
              tenor y a un solo efecto, en la fecha indicada en el presente
              contrato.
            </p>
            {match.params.id ?
            <>
             <Button
              type="danger"
              text="Atras"
              margin={true}
              onClick={() => history.push("/logout")}
            />

            <Button
              type="primary"
              text={
                <Loader loaderColor="#ffffff" isLoading={modelTerminos.loading}>
                  Aceptar terminos y condiciones
                </Loader>
              }
              disabled={modelTerminos.loading}
              margin={true}
              pullRight={true}
              onClick={() => submit()}
            />
            </>
            : null}
          </Box>
        </Col>
      </Row>
    </Content>
  );
}

export default AceptarTerminos;
